<div class="mb-3 flex gap-2 dialog-header">
  <fa-icon [icon]="titleIcon"></fa-icon
  ><span class="font-medium">{{ 'keyboard-shortcuts.keyboardShortcuts' | translate }}</span>
</div>
@for (entry of hotkeyData; track $index) {
  @if (entry.type === 'header') {
    <h2 class="mt-0 mb-2 shortcut-section-title">{{ 'keyboard-shortcuts.' + entry.value | translate }}</h2>
  } @else if (entry.type === 'group') {
    <dl class="shortcut-list">
      @for (action of entry.value; track $index) {
        <div>
          <dt>{{ 'keyboard-shortcuts.' + action | translate }}</dt>
          <dd>
            <kbd>
              <button
                (click)="setKeybind(action)"
                class="set-keybind"
                [class.changing]="changingKey === action"
                [class.overlapping]="isOverlapping(mapping[action])"
                mat-flat-button
              >
                {{ getKeybind(action) }}
              </button>
            </kbd>
            <button
              (click)="resetKeybind(action)"
              class="mat-circle-button reset-keybind"
              mat-button
              [disabled]="defaultKeybinds[action] === mapping[action]"
            >
              <fa-icon [icon]="undoIcon" />
            </button>
          </dd>
        </div>
      }
    </dl>
  }
}

<h2 class="shortcut-section-title">{{ 'keyboard-shortcuts.additionalOptions' | translate }}</h2>
<mat-checkbox [checked]="smoothScroll()" (click)="toggleSignal(smoothScroll)">{{
  'keyboard-shortcuts.smoothScroll' | translate
}}</mat-checkbox>
